import { useEffect, useContext } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import MapContext from './MapContext'
import { getView, mapHash, getViewFromHash } from './utils'

const HashControl = (props) => {
  const map = useContext(MapContext)
  const history = useHistory()
  const location = useLocation()
  const pageuuid = `${location.pathname}?${location.search}`

  useEffect(() => {
    if (!map) return

    const mapChangeHandler = (event) => {
      if (map.isMoving() || event.preserveHash ) return
      const hash = event.originalEvent ? getView(map) : ''
      if (hash === history.location.hash) return
      const location = Object.assign({}, history.location)
      location.hash = hash
      history.replace(location)
    }

    map.on('dragend', mapChangeHandler)
    map.on('zoomend', mapChangeHandler)
    map.on('rotateend', mapChangeHandler)

    return () => {
      if (map && map.off) {
        map.on('dragend', mapChangeHandler)
        map.on('zoomend', mapChangeHandler)
        map.on('rotateend', mapChangeHandler)
      }
    }
  }, [map])

  useEffect(() => {
    const hash = history.location.hash
    if (!map || !hash || !mapHash.test(hash)) return
    const [lat, lng, zoom, bearing] = getViewFromHash(hash)
    const options = {
      center: [lat, lng],
      zoom: zoom,
      bearing: bearing,
      maxZoom: 15
    }
    map.flyTo(options, { preserveHash: true })
  }, [map, history, pageuuid])

  return  null
}

export default HashControl
